export default "__VITE_ASSET__CnXbvMCz__";